// @sportschool/shared-types — Domain Enums mirroring backend Common/Enums

export enum SchoolRole {
  None = 0,
  Admin = 1,
  Coach = 2,
  Student = 4,
}

export enum Gender {
  NotSet = 'NotSet',
  Male = 'Male',
  Female = 'Female',
}

export function getSchoolRoleNames(roles: SchoolRole): string[] {
  const names: string[] = [];
  for (const [key, value] of Object.entries(SchoolRole)) {
    if (typeof value === 'number' && value !== 0 && (roles & value) === value) {
      names.push(key);
    }
  }
  return names;
}

export enum SportType {
  Badminton = 'Badminton',
  Tennis = 'Tennis',
  Squash = 'Squash',
  TableTennis = 'TableTennis',
  Padel = 'Padel',
  Volleyball = 'Volleyball',
  Other = 'Other',
}

/** @deprecated Replaced by dynamic SkillLevel (fetch from `GET /api/v1/schools/{schoolId}/skill-levels`). */
export enum SkillCategory {
  Beginner = 'Beginner',
  Intermediate = 'Intermediate',
  Advanced = 'Advanced',
  Pro = 'Pro',
}

/** Audience a skill level (and groups using it) is meant for. */
export enum SkillLevelCategory {
  Adults = 'Adults',
  Youth = 'Youth',
  Children = 'Children',
}

/** Dynamic skill level as returned by the API. */
export interface SkillLevel {
  id: string;
  namePl: string;
  nameEn: string;
  name?: string; // Optional name fallback
  color: string;
  sortOrder: number;
  category?: SkillLevelCategory;
  createdAt: string;
}


export enum EquipmentType {
  Synthetic = 'Synthetic',
  Feather = 'Feather',
}

export enum SessionType {
  Regular = 'Regular',
  Event = 'Event',
  Private = 'Private',
}

export enum SessionStatus {
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export enum EnrollmentType {
  DropIn = 'DropIn',
  Monthly = 'Monthly',
  MakeUp = 'MakeUp',
  Manual = 'Manual',
}

export enum EnrollmentStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Absent = 'Absent',
  Completed = 'Completed',
}

export enum EnrollmentPaymentStatus {
  Unpaid = 'Unpaid',
  Pending = 'Pending',
  Paid = 'Paid',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
}

export enum AttendanceStatus {
  Present = 'Present',
  Absent = 'Absent',
  NoShow = 'NoShow',
}

export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  WillNotRenew = 'WillNotRenew',
  PendingPayment = 'PendingPayment',
}

export enum CreditStatus {
  Available = 'Available',
  Redeemed = 'Redeemed',
  Expired = 'Expired',
}

export enum PaymentType {
  Cash = 'Cash',
  Card = 'Card',
  BankTransfer = 'BankTransfer',
  Online = 'Online',
  Voucher = 'Voucher',
  Balance = 'Balance',
}

export enum PaymentStatus {
  Pending = 'Pending',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Refunded = 'Refunded',
}

export enum AvailabilityType {
  DateRange = 'DateRange',
  RecurringWeekly = 'RecurringWeekly',
}

export enum AvailabilityStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum SubstitutionStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Declined = 'Declined',
}

export enum EventType {
  SessionReminder = 'SessionReminder',
  AttendanceReminder = 'AttendanceReminder',
  SubstitutionRequest = 'SubstitutionRequest',
  PaymentReceived = 'PaymentReceived',
  Custom = 'Custom',
}

export enum InvoiceStatus {
  Pending = 'Pending',
  Issued = 'Issued',
  Failed = 'Failed',
}

export enum TenantMode {
  Shared = 'Shared',
  Dedicated = 'Dedicated',
}

export enum ResignationRule {
  Standard = 'Standard',
  OneMonthNotice = 'OneMonthNotice',
}

export enum CouponType {
  Amount = 'Amount',
  Percentage = 'Percentage',
  DropInSubscriptionRate = 'DropInSubscriptionRate',
}

export enum DiscountCouponStatus {
  Active = 'Active',
  Redeemed = 'Redeemed',
  PartiallyUsed = 'PartiallyUsed',
  Used = 'Used',
  Expired = 'Expired',
}

export enum WaitlistReason {
  SessionFull = 'SessionFull',
  EnrollmentBlocked = 'EnrollmentBlocked',
  AdvanceSessionNotNearest = 'AdvanceSessionNotNearest',
}

export enum SuspensionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export enum MemberLoginStatus {
  All = 'All',
  LoggedIn = 'LoggedIn',
  NeverLoggedIn = 'NeverLoggedIn',
}


